import { call } from 'redux-saga/effects';

import { ISessionTranscriptSummary, ITranscriptSummaryApiResponse } from './session-transcript-summary.types';
import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/session-transcript-summary.api';
import { ISession } from '../session/session.types';

export function* fetchSessionTranscriptSummary(sessionId: ISession['id']) {
  const response: ITranscriptSummaryApiResponse = yield call(
    apiRequest,
    api.fetchSessionTranscriptSummaryApi(sessionId),
  );

  if (!response) {
    return;
  }

  const transcriptSummary: ISessionTranscriptSummary = {
    id: sessionId,
    summary: response.summary,
    meetingTitle: response.meetingTitle,
    sessionDate: response.sessionDate,
    startedDate: response.startedDate,
  };

  return transcriptSummary;
}
